import React, { useEffect, useState } from "react";
import "./AdminOrder.css";
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from "react-router-dom";
import { Button, Navbar, Nav, Container, Row, Col, Card, Table, Dropdown } from "react-bootstrap";
// import dash from "../src/Photos/Dashboard.png";
// import menu from "../src/Photos/Menu.png";
// import { IoIosArrowForward } from "react-icons/io";
import Account from "../src/Photos/Account.png";
import Logo from "../src/Photos/eximtracfinallogo.png";


// import { FaRegEye } from "react-icons/fa";
// import { FaTrashAlt } from "react-icons/fa";
// import { LuPencil } from "react-icons/lu";

import { hasAccess } from "../src/roleAccess.js";

function AdminOrder() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    // const [toggled, setToggled] = React.useState(false);

    const [input, setData] = useState([]); // Ensure `input` starts as an empty array
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrders = async () => {
            const token = localStorage.getItem("adminToken"); // or "adminToken" if you're using that

            if (!token) {
                console.warn("Token not found. Please log in.");
                return;
            }

            try {
                const res = await fetch('https://api-ft5g.onrender.com/Get-orders', {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                });

                if (!res.ok) {
                    throw new Error(`Failed to fetch orders. Status: ${res.status}`);
                }

                const docs = await res.json();

                if (docs && docs.data) {
                    setData(docs.data);
                    console.log(docs.data);
                } else {
                    console.warn("Data property not found in response:", docs);
                    setData([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setData([]);
            }
        };

        fetchOrders();
    }, []);


    const handleViewOrder = (orderId, userId) => {
        // Store OrderID in localStorage
        localStorage.setItem("selectedOrderId", orderId);

        // Navigate to Order Details Page
        navigate(`/ViewQuotationOrder/${orderId}/${userId}`);
    };

    const handleLogout = () => {
        localStorage.clear();
        // Delay navigation slightly to ensure clear completes
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 100); // 100ms is usually enough
    };

    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        if (!hasAccess("Order Page")) {
            setUnauthorized(true);

            // After 5 seconds, logout and redirect
            const timer = setTimeout(() => {
                localStorage.clear();
                navigate("/AdminLogin");
            }, 3000);

            return () => clearTimeout(timer); // cleanup
        }
    }, [navigate]);

    // ✅ Show unauthorized message if no access
    if (unauthorized) {
        return (
            <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
                <h2>🚫 Access Denied</h2>
                <p>You are not authorized to view this page.<br />You will be logged out in 3 seconds...</p>
            </div>
        );
    }


    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* <Nav className="me-auto">
                                </Nav> */}

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Dashboard Page") && <Nav.Link as={Link} to="/AdminDash" className="adminnavtext">Dashboard</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Customers Page") && <Nav.Link as={Link} to="/Customers" className="adminnavtext">Customers</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Category Page") && <Nav.Link as={Link} to="/Category" className="adminnavtext">Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Sub - Category Page") && <Nav.Link as={Link} to="/SubCategory" className="adminnavtext">Sub-Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Brands Page") && <Nav.Link as={Link} to="/Brands" className="adminnavtext">Brands</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Products Page") && <Nav.Link as={Link} to="/AdminProducts" className="adminnavtext">Products</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Enquiry Page") && <Nav.Link as={Link} to="/Quotations" className="adminnavtext">Enquiries</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Order Page") && <Nav.Link as={Link} to="/AdminOrder" className="adminnavtext">Orders</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Contact Page") && <Nav.Link as={Link} to="/ContactUsResponse" className="adminnavtext">Contact</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Offline Order Page") && <Nav.Link as={Link} to="/OfflineOrder" className="adminnavtext">Offline Order</Nav.Link>}
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 responsiveview" id="dropdown-basic">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                                    {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                                    {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 mobileview" id="dropdown-basic">
                            <img src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                            {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                            {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            <Container fluid className="mt-3">
                <Row>
                    <Col>
                        <Card>
                            <Row className="p-3">
                                <Col lg={6} xs={6}>
                                    <p className="quotations">ORDERS</p>
                                </Col>

                                {/* <Col lg={6} xs={6} className="text-end">
                                        <Button className="quotationsaddnewcatebtn">
                                            <Link className="quotationsaddnewcatelink">
                                                Add New Quotations
                                            </Link>
                                        </Button>
                                    </Col> */}
                            </Row>

                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            Sr No.
                                        </th>

                                        <th className="">
                                            Order ID
                                        </th>

                                        <th>
                                            Proforma Invoice No.
                                        </th>

                                        <th>
                                            User ID
                                        </th>

                                        <th>
                                            Email ID
                                        </th>

                                        <th>
                                            Customer Name
                                        </th>

                                        <th>
                                            Company Name
                                        </th>

                                        <th>
                                            Enquiry Date
                                        </th>

                                        <th>
                                            View
                                        </th>

                                        <th>
                                            Shipping Status
                                        </th>
                                        {/* <th>
                                            Action
                                        </th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {input.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {index + 1}
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{item.OrderID}</p>
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{item.ProformaInvoiceNumber}</p>
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{item.UserID}</p>
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{item.EmailID}</p>
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{item.FirstName} {item.LastName}</p>
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{item.CompanyName}</p>
                                            </td>

                                            <td>
                                                <p className="mt-2 ccn">{new Date(item.UploadDate).toLocaleDateString()}</p>
                                            </td>


                                            <td>
                                                {/* <Button onClick={scrollToTop} className="mt-1 dotbtn">
                                                <Link to="/ViewQuotationOrder" className="dotlink">
                                                    View Order / Quotations
                                                </Link>
                                            </Button> */}

                                                {hasAccess("Order Page") && <Button className="mt-1 dotbtn" onClick={() => handleViewOrder(item.OrderID, item.UserID)}>View Order</Button>}
                                            </td>

                                            <td>
                                                <p className="text-center mt-2">{item.ShippingStatus}</p>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card>
                    </Col >
                </Row >
            </Container >
            {/* </div> */}
        </>
    );
}

export default AdminOrder;